import React, { useState, useEffect } from 'react';
import './Style/UserDoubt.css';
import { Link } from 'react-router-dom';
import { API_CONFIG } from './../../config';

const USERDOUBT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERDOUBT}`;


const UserDoubt = () => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await fetch(USERDOUBT);
                const data = await response.json();
                if (data.success) {
                    setMessages(data.data || []);
                }
            } catch (err) {
                console.error("Fetch error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchMessages();
    }, []);

    const formatIST = (dateString) => {
        const date = new Date(dateString);
        // Adding 5 hours and 30 minutes in milliseconds
        const IST_OFFSET = (5 * 60 + 30) * 60 * 1000;
        const adjustedDate = new Date(date.getTime() + IST_OFFSET);

        return {
            day: adjustedDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }),
            time: adjustedDate.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })
        };
    };

    if (loading) return <div className="loader">Synchronizing...</div>;

    return (
        <div className="report-container">
            <div className="report-header">
                <h3>Reported Mistakes</h3>
                <span className="count-pill">{messages.length}</span>
            </div>

            <div className="report-list">
                {messages.map((msg, index) => {
                    const { day, time } = formatIST(msg.date);

                    // Calculation: If there are 5 items, the first (index 0) becomes 5 - 0 = 5
                    const displayId = messages.length - index;

                    return (
                        <div key={msg.id} className="report-item-wrapper">
                            <Link to={`/report-question-details/${msg.questionId}/${displayId}/${msg.message}`} className="report-row">
                                <div className="id-group">
                                    <span className="type-tag">{msg.type}</span>
                                    <span className="subject-text">{msg.subject}</span>
                                    <p>{msg.questionId}</p>
                                </div>
                                <div className="time-group">
                                    <span className="count-number">{displayId}</span>
                                    <span className="date-text">{day}</span>
                                    <span className="time-text">{time}</span>
                                </div>
                            </Link>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default UserDoubt;